import { Component, OnInit, ViewChild, Input, OnDestroy } from '@angular/core';

import {NetworkHelperService} from '../../_services/network-helper.service';
import {FORMS, API, CODFUNC, PAGE, GENERALES} from '../../_config/strings';
import { Router, ActivatedRoute, NavigationStart, Event as NavigationEvent } from '@angular/router';
import {Usuario} from '../../_model/Usuario';
import {Subject} from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'app-center-content',
  templateUrl: './center-content.component.html',
  styleUrls: ['./center-content.component.scss']
})
export class CenterContentComponent implements OnInit, OnDestroy {

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();

  FORMS: any;
  API: any;
  CODFUNC: any;
  PAGE: any;
  GENERALES: any;

  public usuario: Usuario = new Usuario();


  constructor() {
  
}

  ngOnInit() {

  }

ngOnDestroy()
{

}

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_shared/center-content/center-content.component.ts